import { computed, ref } from 'vue';

const sortyLiveMode = ref(null);
const sortyLiveConversationUuid = ref(null);

const isSortyLiveOpen = computed(
  () => !!sortyLiveMode.value && !!sortyLiveConversationUuid.value
);

export function useSortyLiveSession() {
  function openSortyLiveSession({ mode, conversationUuid }) {
    sortyLiveMode.value = mode;
    sortyLiveConversationUuid.value = conversationUuid;
  }

  function closeSortyLiveSession() {
    sortyLiveMode.value = null;
    sortyLiveConversationUuid.value = null;
  }

  return {
    sortyLiveMode,
    sortyLiveConversationUuid,
    isSortyLiveOpen,
    openSortyLiveSession,
    closeSortyLiveSession,
  };
}
